import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { Plus, Search, UserCheck, UserX } from 'lucide-react';
import toast from 'react-hot-toast';

const roleLabels = { superadmin:'Super Admin', admin_empresa:'Admin Empresa', project_manager:'Project Manager', supervisor:'Supervisor', tecnico:'Técnico', cliente:'Cliente', viewer:'Visualizador' };

export default function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [showNew, setShowNew] = useState(false);
  const [form, setForm] = useState({ email:'', password:'', firstName:'', lastName:'', role:'tecnico', phone:'' });

  useEffect(() => { loadUsers(); }, [search]);

  const loadUsers = () => {
    setLoading(true);
    api.get('/users', { params: { search: search || undefined } })
      .then(r => setUsers(r.data.data))
      .catch(() => toast.error('Error cargando usuarios'))
      .finally(() => setLoading(false));
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      await api.post('/users', form);
      toast.success('Usuario creado');
      setShowNew(false);
      setForm({ email:'', password:'', firstName:'', lastName:'', role:'tecnico', phone:'' });
      loadUsers();
    } catch (err) { toast.error(err.response?.data?.error || 'Error'); }
  };

  return (
    <div className="page-users">
      <div className="page-header">
        <div><h1>Usuarios</h1><p className="subtitle">Gestión de usuarios del sistema</p></div>
        <button className="btn btn-primary" onClick={() => setShowNew(true)}><Plus size={18} /> Nuevo usuario</button>
      </div>
      <div className="filters-bar">
        <div className="search-box"><Search size={18} /><input placeholder="Buscar..." value={search} onChange={e => setSearch(e.target.value)} /></div>
      </div>
      {loading ? <div className="loading-screen"><div className="spinner" /></div> : (
        <table className="data-table">
          <thead><tr><th>Nombre</th><th>Email</th><th>Rol</th><th>Empresa</th><th>Estado</th></tr></thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id}>
                <td className="user-cell"><div className="avatar-sm">{u.first_name?.[0]}{u.last_name?.[0]}</div>{u.first_name} {u.last_name}</td>
                <td>{u.email}</td>
                <td><span className="role-badge">{roleLabels[u.role]}</span></td>
                <td>{u.company_name || '-'}</td>
                <td>{u.is_active ? <UserCheck size={16} className="text-green" /> : <UserX size={16} className="text-red" />}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {showNew && (
        <div className="modal-overlay" onClick={() => setShowNew(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Nuevo Usuario</h2>
            <form onSubmit={handleCreate}>
              <div className="form-row">
                <div className="form-group"><label>Nombre *</label><input required value={form.firstName} onChange={e => setForm({...form, firstName: e.target.value})} /></div>
                <div className="form-group"><label>Apellido *</label><input required value={form.lastName} onChange={e => setForm({...form, lastName: e.target.value})} /></div>
              </div>
              <div className="form-group"><label>Email *</label><input type="email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} /></div>
              <div className="form-group"><label>Contraseña *</label><input type="password" required minLength={8} value={form.password} onChange={e => setForm({...form, password: e.target.value})} /></div>
              <div className="form-row">
                <div className="form-group"><label>Rol *</label>
                  <select value={form.role} onChange={e => setForm({...form, role: e.target.value})}>
                    {Object.entries(roleLabels).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                <div className="form-group"><label>Teléfono</label><input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} /></div>
              </div>
              <div className="form-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setShowNew(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary">Crear</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
